'use client';
import { BiLoaderAlt, RxCross2, TbFile, BsDownload } from '@/components/Icon';
import { Typography } from '@/components/Typography';
import { handleDownload } from '@/utils/downloadFile';
import { formatFileSize } from '@/utils/fileSize';

interface FilePreviewProps {
  handleFileDelete?: (name: string, id?: string) => void;
  isUploadPending?: boolean;
  name: string;
  size: number;
  id?: string;
  type: 'Upload' | 'Download';
  fileUrl?: string;
}
const FilePreview = ({
  handleFileDelete,
  name,
  size,
  id,
  isUploadPending = false,
  type,
  fileUrl,
}: FilePreviewProps) => {
  return (
    <div className="relative flex items-center gap-x-2 rounded-md border px-4 py-1">
      <TbFile size={20} />
      <div>
        <Typography.BodyRegularSmall>{name}</Typography.BodyRegularSmall>
        <Typography.BodyRegularExtraSmall>
          {formatFileSize(size)}
        </Typography.BodyRegularExtraSmall>
      </div>
      {type === 'Upload' ? (
        <button
          disabled={isUploadPending}
          onClick={() => handleFileDelete?.(name, id)}
          className="absolute -right-1.5 -top-1.5 z-10 flex items-center justify-center rounded-full border bg-content-brand p-1 hover:bg-content-brand/80 disabled:pointer-events-none"
        >
          {isUploadPending ? (
            <BiLoaderAlt className="animate-spin" />
          ) : (
            <RxCross2 />
          )}
        </button>
      ) : (
        <button
          onClick={() => handleDownload(fileUrl!, name)}
          className="absolute -right-1.5 -top-1.5 z-10 flex items-center justify-center rounded-full border bg-content-brand p-1 hover:bg-content-brand/80 disabled:pointer-events-none"
        >
          <BsDownload />
        </button>
      )}
    </div>
  );
};

export { FilePreview };
